module.exports = __webpack_public_path__ + "img/zen.fcc07749.svg";